//=============================================================================
//   common script
//=============================================================================

//nav height adjustment
//---------------------------------------------------------------
$(function () {
   if (!$('header .cat-nav').length) {
      $('.js-menu').addClass('is-moved');
      $('body').addClass('is-moved');
   }
});

//menu
//---------------------------------------------------------------
$(function () {
   let toggle_el = $('.js-toggle');
   let menu_el = $('.js-menu');
   let anime_el = $('.js-menu .fadeIn');
   let screen_el = $('.js-screen');
   let open_class_name = 'is-open';
   let active_class_name = 'is-active';
   let no_animation_name = 'is-no-animation';

   toggle_el.click(function () {
      if ($(this).hasClass(open_class_name)) {
         $(this).removeClass(open_class_name);
         menu_el.removeClass(open_class_name);
         anime_el.removeClass(active_class_name);
         screen_el.fadeOut(500);

         //
         $('html').css({
            overflow: '',
         });
         document.removeEventListener('touchmove', scrollControl, {
            passive: false,
         });

      } else {
         $(this).removeClass(no_animation_name);
         $(this).addClass(open_class_name);
         menu_el.addClass(open_class_name);
         screen_el.fadeIn(500);

         //
         $('html').css({
            overflow: 'hidden',
         });
         document.addEventListener('touchmove', scrollControl, {
            passive: false,
         });

         setTimeout(function () {
            anime_el.addClass(active_class_name);
         }, 0);
      }
   });
   screen_el.click(function () {
      let toggle_el = $('.js-toggle');
      toggle_el.removeClass(open_class_name);
      menu_el.removeClass(open_class_name);
      anime_el.removeClass(active_class_name);
      screen_el.fadeOut(500);
   });

   let scrollControl = function (event) {
      if ($(event.target).closest('.js-menu').length > 0) {
         event.stopPropagation();
      } else {
         event.preventDefault();
      }
   }

});


//  modal
//---------------------------------------------------------------
$(function () {
   // open
   $('.js-modal-trigger').on('click', function (e) {
      let target = $(this).data('target');
      let modal = document.getElementById(target);
      $(modal).fadeIn(200).addClass('is-active');

      //
      $('html').css({
         overflow: 'hidden',
      });
      document.addEventListener('touchmove', scrollControl, {
         passive: false,
      });

      return false;
   });

   // close
   $('.js-modal-close, .js-modal-add-cart').on('click', function (e) {
      if (e.target != e.currentTarget) return false;
      $('.js-modal').removeClass('is-active').fadeOut(200);

      //
      $('html').css({
         overflow: '',
      });
      document.removeEventListener('touchmove', scrollControl, {
         passive: false,
      });

      return false;
   });

   let scrollControl = function (event) {
      if ($(event.target).closest('.js-modal > div').length > 0) {
         event.stopPropagation();
      } else {
         event.preventDefault();
      }
   };
});

//- accordion
//---------------------------------------------------------------
$(function () {
   $('.js-accordion-trigger').click(function () {
      $(this).nextAll('.js-accordion-target:first').slideToggle();
      $(this).toggleClass('is-toggle');
      return false;
   });
});

//- twin accordion
//---------------------------------------------------------------
$(function () {
   $('.js-twin-accordion-trigger').click(function () {
      $(this).nextAll('.js-twin-accordion-target:first').slideToggle();
      $(this).toggleClass('is-toggle');
      $('.js-twin-accordion-trigger').not(this).each(function(){
         $(this).nextAll('.js-twin-accordion-target:first').slideUp();
         $(this).removeClass('is-toggle');
      });
      $('.js-grad-trigger').prop('checked', true);//もっと見るを解除
      return false;
   });
});

//- drill down
//---------------------------------------------------------------
$(function () {
   $('.js-drilldown-trigger').click(function () {
      $(this).nextAll('.js-drilldown-target:first').toggleClass('is-toggle');
      $(this).closest('.js-drilldown').toggleClass('is-toggle');
      return false;
   });

   $('.js-drilldown-back').click(function () {
      $(this).parent('.js-drilldown-target').toggleClass('is-toggle');
      $(this).closest('.js-drilldown').toggleClass('is-toggle');
      return false;
   });

   //  search
   //---------------------------------------------------------------
   $('.js-drilldown-back').click(function () {
      let label = $(this)
         .parent('.js-drilldown-target')
         .prev('.js-drilldown-trigger')
         .find('.js-drilldown-label');
      let form_el = $(this)
         .parent('.js-drilldown-target')
         .find(
            'input[type="radio"]:checked, input[type="checkbox"]:checked, select'
         );

      //radio
      if (form_el.is('input[type="radio"]')) {
         let val = form_el.val();
         let input_name = form_el.next().text();
         label.text('').text(input_name);
         return false;
      }

      //checkbox
      if (form_el.is('input[type="checkbox"]')) {
         label.text('').text('ON');
         return false;
      }

      //select
      if (form_el.is('select')) {
         form_el.each(function () {
            let option = $(this).children('option:selected');
            if (option.val() != '') {
               let option_name = option.text();
               label.text('').text(option_name);
            }
         });
         return false;
      }

      //none of above
      label.text('').text('指定なし');
   });
});

// radio switchable
//---------------------------------------------------------------
$(function () {
   //js-switchable
   let radio_group = {};
   $('.js-switchable').each(function (index) {
      radio_group[index] = null;
   });

   $('.js-switchable').on('click', function () {
      let num = $('input').index($(this) - 1);

      //- console.log(num);
      if ($(this).val() == radio_group[num]) {
         $(this).prop('checked', false);
         radio_group[num] = null;
      } else {
         radio_group[num] = $(this).val();
      }
   });
});

// link copy
//---------------------------------------------------------------
$(function () {
   // クリップボードへのコピー実装
   var clipboard = new ClipboardJS('.copy_btn');
   // コピー成功時（CSSクラスを追加してテキストを変更）
   clipboard.on('success', function (e) {
      $(".copy_btn").addClass('isCopied').html('<span>リンクをコピーしました</span>');
   });
   // エラー時
   clipboard.on('error', function (e) {
      $(".copy_btn").addClass('isCopied').text('お使いのブラウザはこの機能に対応していません');
   });

});